import * as React from 'react';

import { FormContext } from '~context/FormContext';

export const useRemoveHighlightOnFocus = (fieldName: string) => {
    const { removeHighlight, highlightedFields } = React.useContext(FormContext);
    const highlighted = highlightedFields.has(fieldName);

    const onFocus = React.useCallback(() => {
        highlighted && removeHighlight(fieldName);
    }, [highlighted, fieldName]);

    return onFocus;
};
